/* DD · scripts for the sections and blocks carried over from the old theme. Each part guards itself so it only runs once. */
/* ---- blocks/dd-bundle-picker.liquid ---- */
  (function () {
    if (window.__ddhBundlePickerV1) return;
    window.__ddhBundlePickerV1 = true;

    function markSelected(root, card) {
      root.querySelectorAll('.ddh-bp__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function selectInTheme(card) {
      var id = card.getAttribute('data-option-value-id');
      var scope = card.closest('.shopify-section') || document;
      var input = scope.querySelector('variant-picker input[data-option-value-id="' + id + '"]');
      if (input) {
        if (!input.checked) input.click();
        return true;
      }
      var opt = scope.querySelector('variant-picker option[data-option-value-id="' + id + '"]');
      if (opt) {
        var sel = opt.closest('select');
        if (sel && sel.value !== opt.value) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.ddh-bp__card');
      if (!card) return;
      e.preventDefault();
      var root = card.closest('.ddh-bp');
      if (!root) return;
      markSelected(root, card);
      if (!selectInTheme(card)) {
        var vid = card.getAttribute('data-variant-id');
        if (vid) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          window.location.href = url.toString();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      var card = e.target.closest && e.target.closest('.ddh-bp__card');
      if (!card) return;
      if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var cards = Array.prototype.slice.call(card.closest('.ddh-bp').querySelectorAll('.ddh-bp__card'));
      var i = cards.indexOf(card);
      var next = cards[(i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + cards.length) % cards.length];
      next.focus();
      next.click();
    });

    /* Keep cards in sync if the variant changes from somewhere else (e.g. URL or another picker). */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('variant-picker input[type="radio"]')) return;
      var scope = input.closest('.shopify-section') || document;
      var id = input.getAttribute('data-option-value-id');
      scope.querySelectorAll('.ddh-bp').forEach(function (root) {
        var card = root.querySelector('.ddh-bp__card[data-option-value-id="' + id + '"]');
        if (card) markSelected(root, card);
      });
    });
  })();

/* ---- blocks/dd-delivery-timeline.liquid ---- */
  (function () {
    if (window.__ddhDeliveryTimelineV1) return;
    window.__ddhDeliveryTimelineV1 = true;
    var EN_DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    function list(str, fallback) {
      var parts = (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      return parts.length ? parts : fallback;
    }

    function addDays(base, n, skip) {
      var d = new Date(base.getTime());
      var added = 0;
      var guard = 0;
      while (added < n && guard < 400) {
        d.setDate(d.getDate() + 1);
        guard++;
        if (skip.indexOf(EN_DAYS[d.getDay()]) === -1) added++;
      }
      return d;
    }

    function fmt(d, format, months, days) {
      var m = months[d.getMonth()] || '';
      var dd = d.getDate();
      var wd = days[(d.getDay() + 6) % 7] || '';
      switch (format) {
        case 'dd_mm': return dd + ' ' + m;
        case 'dd/mm': return dd + '/' + (d.getMonth() + 1);
        case 'weekday': return wd + ', ' + m + ' ' + dd;
        default: return m + ' ' + dd;
      }
    }

    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-ddh-dt]').forEach(function (el) {
        var months = list(el.getAttribute('data-months'), ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
        var days = list(el.getAttribute('data-days'), ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
        var skip = list(el.getAttribute('data-skip'), []).map(function (s) { return s.slice(0, 3).toLowerCase(); });
        var format = el.getAttribute('data-format');
        var today = new Date();
        el.querySelectorAll('.ddh-dt__step').forEach(function (step) {
          var min = parseInt(step.getAttribute('data-min'), 10) || 0;
          var max = parseInt(step.getAttribute('data-max'), 10) || min;
          var s = step.querySelector('[data-ddh-start]');
          var e = step.querySelector('[data-ddh-end]');
          if (s) s.textContent = fmt(addDays(today, min, skip), format, months, days);
          if (e) e.textContent = fmt(addDays(today, Math.max(min, max), skip), format, months, days);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) { init(e.target.closest('.shopify-section') || document); });
    /* Horizon re-renders parts of the product section after a variant change; refill any empty dates. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (document.querySelector('[data-ddh-dt] [data-ddh-start]:empty, [data-ddh-dt] [data-ddh-end]:empty')) init();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

/* ---- blocks/dd-review-slider.liquid ---- */
  (function () {
    if (window.__ddhReviewSliderV1) return;
    window.__ddhReviewSliderV1 = true;
    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('[data-ddh-rv-dot]');
      if (!dot) return;
      var root = dot.closest('[data-ddh-rv]');
      var track = root && root.querySelector('[data-ddh-rv-track]');
      if (!track) return;
      var i = parseInt(dot.getAttribute('data-ddh-rv-dot'), 10) || 0;
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
    document.addEventListener('scroll', function (e) {
      var track = e.target;
      if (!track || !track.matches || !track.matches('[data-ddh-rv-track]')) return;
      var root = track.closest('[data-ddh-rv]');
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      root.querySelectorAll('[data-ddh-rv-dot]').forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }, true);
  })();

/* ---- sections/dd-collection-slider.liquid ---- */
  (function () {
    if (window.__ddhSliderNavV1) return;
    window.__ddhSliderNavV1 = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ddh-slider-prev], [data-ddh-slider-next]');
      if (!btn) return;
      var root = btn.closest('[data-ddh-slider]');
      var track = root && root.querySelector('[data-ddh-slider-track]');
      if (!track || !track.firstElementChild) return;
      var step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      var dir = btn.hasAttribute('data-ddh-slider-next') ? 1 : -1;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });
  })();

/* ---- sections/dd-scroll-progress.liquid ---- */
  (function () {
    if (window.__ddhScrollProgressV1) return;
    window.__ddhScrollProgressV1 = true;
    var ticking = false;
    /* On computers (990px and wider) Horizon scrolls the page inside .page-wrapper instead of the window. */
    function scroller() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible') return pw;
      return null;
    }
    function update() {
      ticking = false;
      var pw = scroller();
      var max = pw ? pw.scrollHeight - pw.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
      var y = pw ? pw.scrollTop : window.scrollY;
      var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
      document.querySelectorAll('[data-ddh-sp-fill]').forEach(function (f) { f.style.transform = 'scaleX(' + p + ')'; });
    }
    /* capture: also hears scrolling of .page-wrapper, which does not bubble up to the window */
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true, capture: true });
    window.addEventListener('resize', update);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  })();

/* ---- sections/dd-ticker.liquid ---- */
  (function () {
    if (window.__ddhTickerV1) return;
    window.__ddhTickerV1 = true;
    var originals = new WeakMap();
    function setup(el) {
      var track = el.querySelector('[data-ddh-tk-track]');
      if (!track) return;
      var groups = track.querySelectorAll('.ddh-tk__group');
      if (groups.length < 2) return;
      var first = groups[0];
      if (!originals.has(first)) originals.set(first, first.innerHTML);
      var tries = 0;
      while (first.scrollWidth < el.clientWidth && tries < 8) {
        first.insertAdjacentHTML('beforeend', originals.get(first));
        tries++;
      }
      groups[1].innerHTML = first.innerHTML;
      groups[1].querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
      var pxPerSec = 30 * (parseFloat(el.getAttribute('data-speed')) || 2);
      var duration = Math.max(first.scrollWidth / pxPerSec, 4);
      el.style.setProperty('--ddh-tk-duration', duration + 's');
    }
    function init(root) { (root || document).querySelectorAll('[data-ddh-tk]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    window.addEventListener('load', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

/* ---- sections/dd-track-order.liquid ---- */
  (function () {
    if (window.__ddhTrackOrderV1) return;
    window.__ddhTrackOrderV1 = true;
    var loading = null;
    function load17() {
      if (window.YQV5) return Promise.resolve();
      if (loading) return loading;
      loading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.onload = function () { resolve(); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
      return loading;
    }
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-ddh-to-form]');
      if (!form) return;
      e.preventDefault();
      var root = form.closest('[data-ddh-to]');
      var num = form.querySelector('input').value.trim();
      if (!num) return;
      var result = root.querySelector('.ddh-to__result');
      load17().then(function () {
        window.YQV5.trackSingle({ YQ_ContainerId: result.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
      }).catch(function () {
        window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
      });
    });
  })();

/* ---- sections/dd-video-reels.liquid ---- */
  (function () {
    if (!window.__ddhSliderNavV1) {
      window.__ddhSliderNavV1 = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-ddh-slider-prev], [data-ddh-slider-next]');
        if (!btn) return;
        var root = btn.closest('[data-ddh-slider]');
        var track = root && root.querySelector('[data-ddh-slider-track]');
        if (!track || !track.firstElementChild) return;
        var step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        var dir = btn.hasAttribute('data-ddh-slider-next') ? 1 : -1;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    }

    if (window.__ddhVideoReelsV1) return;
    window.__ddhVideoReelsV1 = true;
    var isPhone = window.matchMedia('(max-width: 749px)');

    function load(video) {
      if (video.dataset.loaded) return;
      var src = isPhone.matches ? video.dataset.srcM : video.dataset.srcD;
      if (!src) return;
      video.src = src;
      video.dataset.loaded = '1';
    }
    function setState(video) {
      var media = video.closest('.ddh-vr__media');
      if (media) media.classList.toggle('is-playing', !video.paused);
    }
    function tryPlay(video) {
      load(video);
      var p = video.play();
      if (p && p.catch) p.catch(function () { setState(video); });
    }

    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (!v.dataset.userPaused) tryPlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] }) : null;

    function init(root) {
      (root || document).querySelectorAll('[data-ddh-vr] .ddh-vr__video').forEach(function (v) {
        if (v.dataset.ddhInit) return;
        v.dataset.ddhInit = '1';
        v.muted = true;
        ['play', 'playing', 'pause', 'ended'].forEach(function (ev) { v.addEventListener(ev, function () { setState(v); }); });
        var stuckTimer;
        v.addEventListener('waiting', function () {
          clearTimeout(stuckTimer);
          stuckTimer = setTimeout(function () { if (v.readyState < 3 && !v.paused) { var t = v.currentTime; v.load(); v.currentTime = t; tryPlay(v); } }, 5000);
        });
        v.addEventListener('playing', function () { clearTimeout(stuckTimer); });
        if (io) io.observe(v); else tryPlay(v);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ddh-vr-play]');
      var media = e.target.closest && e.target.closest('.ddh-vr__media');
      if (!btn && !(media && e.target.classList.contains('ddh-vr__video'))) return;
      var v = (btn || media).closest('.ddh-vr__media').querySelector('.ddh-vr__video');
      if (!v) return;
      if (v.paused) { delete v.dataset.userPaused; tryPlay(v); } else { v.dataset.userPaused = '1'; v.pause(); }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

/* ---- blocks/buy-buttons.liquid: Buy it now (add to cart, then straight to checkout) ---- */
  (function () {
    if (window.__ddhBuyNowV1) return;
    window.__ddhBuyNowV1 = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ddh-buy-now]');
      if (!btn) return;
      e.preventDefault();
      var form = btn.closest('form');
      if (!form) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.classList.add('is-loading');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'checkout';
      }).catch(function () {
        btn.classList.remove('is-loading');
        /* let the theme's own Add to cart show its message (e.g. sold out) */
        var atc = form.querySelector('[type="submit"][name="add"], .add-to-cart-button');
        if (atc) atc.click();
      });
    });
  })();

/* ---- sections/dd-image-slider.liquid: autoplay (arrows use the shared slider nav) ---- */
  (function () {
    if (window.__ddhImageSliderV1) return;
    window.__ddhImageSliderV1 = true;
    function start(root) {
      if (root.dataset.ddhIsInit || root.getAttribute('data-autoplay') !== 'true') return;
      root.dataset.ddhIsInit = '1';
      var track = root.querySelector('[data-ddh-slider-track]');
      if (!track || !track.firstElementChild) return;
      var ms = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
      var paused = false;
      root.addEventListener('pointerenter', function () { paused = true; });
      root.addEventListener('pointerleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        var step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step, behavior: 'smooth' });
      }, ms);
    }
    function init(scope) { (scope || document).querySelectorAll('[data-ddh-is]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
